import { ProductFilterable } from '@utils/productDto';
import { ProductFilters } from 'app/types/filters';
import { ProductType } from 'app/types/product';

export const INITIAL_FILTERS = {
  category: [],
  zone: [],
  clinic: [],
  text: '',
  price: [],
  type: [],
};

export const PSRP_MULTIPLETYPES_PRODUCTS = [
  {
    type: ProductType.Longevity,
    products: ['Exosomas'],
  },
];

export const applyFilters = <T extends ProductFilterable>({
  products,
  filters,
}: {
  products: T[];
  filters: ProductFilters;
}): T[] => {
  const updatedProducts = products.map(product => {
    const isVisibleByCategory =
      filters.category.length == 0 ||
      product.category.some(category =>
        filters.category.includes(category.name)
      );

    let isVisibleByType = [ProductType.GlowBox, ProductType.GiftCard].includes(
      product.type
    )
      ? true
      : filters.type.length > 0
        ? filters.type.includes(product.type)
        : true;
    PSRP_MULTIPLETYPES_PRODUCTS.forEach(multipleType => {
      if (
        filters.type.includes(multipleType.type) &&
        multipleType.products.includes(product.title)
      ) {
        isVisibleByType = true;
      }
    });
    const isVisibleByZone =
      filters.zone.length == 0 || filters.zone.includes(product.zone);

    const productClinics: Array<string | undefined> = (
      product.clinicDetail ?? []
    ).map(item => item.clinic?.internalName);

    const isVisibleByClinic =
      filters.clinic.length == 0 ||
      filters.clinic.some(clinic => productClinics.includes(clinic));

    let isVisibleByPrice = filters.price.length == 0;
    filters.price.forEach(x => {
      switch (x) {
        case 1:
          isVisibleByPrice = isVisibleByPrice || product.price < 250;
          break;
        case 2:
          isVisibleByPrice =
            isVisibleByPrice || (product.price >= 250 && product.price < 500);
          break;
        case 3:
          isVisibleByPrice = isVisibleByPrice || product.price >= 500;
          break;
      }
    });

    const isVisibleByText =
      filters.text.length === 0 ||
      normalizeText(product.title).includes(normalizeText(filters.text)) ||
      normalizeText(product.description).includes(
        normalizeText(filters.text)
      ) ||
      normalizeText(product.longDescription).includes(
        normalizeText(filters.text)
      );

    const productVisibility = [
      isVisibleByCategory,
      isVisibleByZone,
      isVisibleByClinic,
      isVisibleByPrice,
      isVisibleByText,
      isVisibleByType,
    ].every(value => value === true);

    return { ...product, visibility: productVisibility } as T;
  });

  return updatedProducts;
};

export const normalizeText = (text: string) => {
  if (!text) return text;
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};
export const filterCount = (filters: ProductFilters) => {
  let filterCount = 0;

  if (filters.text) {
    filterCount += 1;
  }
  filterCount = filterCount + filters.category.length;
  filterCount = filterCount + filters.zone.length;
  filterCount = filterCount + filters.clinic.length;
  filterCount = filterCount + filters.price.length;
  filterCount = filterCount + filters.type.length;

  return filterCount;
};

export const toggleCategory = ({
  category,
  filters,
}: {
  category: string;
  filters: ProductFilters;
}) => {
  const updatedFilters: ProductFilters = { ...filters } || {};

  const categoryIndex = updatedFilters.category.indexOf(category);

  if (categoryIndex === -1) {
    updatedFilters.category.push(category);
  } else {
    updatedFilters.category.splice(categoryIndex, 1);
  }

  return updatedFilters;
};

export const toggleZone = ({
  zone,
  filters,
}: {
  zone: number;
  filters: ProductFilters;
}) => {
  const updatedFilters: ProductFilters = { ...filters } || {};
  const zoneIndex = updatedFilters.zone.indexOf(zone);

  if (zoneIndex === -1) {
    updatedFilters.zone.push(zone);
  } else {
    updatedFilters.zone.splice(zoneIndex, 1);
  }

  return updatedFilters;
};

export const toggleFilter = ({
  filter,
  value,
  filters,
}: {
  filter: 'category' | 'zone' | 'clinic' | 'text' | 'price' | 'type';
  value: string | number;
  filters: ProductFilters;
}) => {
  const updatedFilters: ProductFilters = { ...filters } || {};
  if (filter == 'text') {
    updatedFilters.text = value.toString();
  } else {
    const valueIndex = (
      updatedFilters[filter] as Array<string | number>
    ).indexOf(value);

    if (valueIndex === -1) {
      (updatedFilters[filter] as Array<string | number>).push(value);
    } else {
      updatedFilters[filter].splice(valueIndex, 1);
    }
  }
  return updatedFilters;
};
